document.addEventListener('DOMContentLoaded', function () {
  CF.ready(function () {
    // 利用規約とプライバシーポリシーの挿入
    const termsElement = document.querySelector('.js-appendCfApp');
    const genderField = document.querySelector('.cf-field-container.c_customer-personal_information');
    if (termsElement && genderField) {
      termsElement.style.display = 'block';
      genderField.parentNode.insertBefore(termsElement, genderField);
    }

    // アコーディオンの処理
    const accordions = document.querySelectorAll('.cf-field-container.js-helium-accordion__container');
    
    if (accordions) {
      accordions.forEach(accordion => {
        const title = accordion.querySelector('.cf-field-container.js-helium-accordion__title');
        const contents = accordion.querySelectorAll('.cf-field-container.js-helium-accordion__content');

        contents.forEach(content => {
          content.style.display = 'none';
        });

        if (title && contents) {
          title.addEventListener('click', () => {
            title.classList.toggle('is-open');
            contents.forEach(content => {
              content.style.display = content.style.display === 'none' || !content.style.display ? 'block' : 'none';
            });
          });
        }
      });
    }

    const ShopAccordions = document.querySelectorAll('.cf-field-container.js-helium-accordion__container.c_shop-container');
    const allShopAccordions = document.querySelectorAll('.cf-field-container.js-helium-accordion__container--all');
    ShopAccordions.forEach(accordion => {
      accordion.classList.add('is-hidden');
    });

    allShopAccordions.forEach(accordion => {
      accordion.addEventListener('click', () => {
        accordion.classList.toggle('is-open');
        ShopAccordions.forEach(accordion => {
          if(accordion.classList.contains('is-hidden')) {
            accordion.classList.remove('is-hidden');
          } else {
            accordion.classList.add('is-hidden');
          }
        });
      });
    });

    const termsInnerElements = document.querySelectorAll('.terms-of-service__inner');
    termsInnerElements.forEach((element, index) => {
      if(element.scrollHeight > element.clientHeight) {
        const scrollPercentage = (element.scrollTop / (element.scrollHeight - element.clientHeight)) * 100;
        element.style.setProperty('--scroll-progress', `${scrollPercentage}`);
      } else {
        element.style.setProperty('--scroll-progress', '100');
      }

      element.addEventListener('scroll', () => {
        const scrollPercentage = (element.scrollTop / (element.scrollHeight - element.clientHeight)) * 100;
        element.style.setProperty('--scroll-progress', `${scrollPercentage}`);
      });
    });

    // パスワードを表示する
    function createPasswordToggle(input) {
      // 非表示時のSVG
      const hiddenSvg = `
        <g opacity="0.4">
          <path d="M12.9872 15.1835C8.27289 15.1835 3.82465 12.7891 1.08525 8.7786C0.971582 8.61311 0.971582 8.39073 1.08525 8.22524C3.8259 4.21343 8.27414 1.82031 12.9872 1.82031C17.7003 1.82031 22.1772 4.21343 24.9166 8.22395C25.0303 8.38944 25.0303 8.61181 24.9166 8.7773C22.1785 12.7878 17.7177 15.1822 12.9872 15.1822V15.1835ZM2.03711 8.50063C4.61536 12.091 8.68386 14.2255 12.9884 14.2255C17.293 14.2255 21.3878 12.091 23.9673 8.50063C21.3878 4.9103 17.3093 2.77704 12.9884 2.77704C8.66762 2.77704 4.61536 4.9103 2.03711 8.50063Z" fill="black" stroke="black"/>
          <path d="M12.9871 12.6146C10.7936 12.6146 9.00977 10.7683 9.00977 8.49805C9.00977 6.22775 10.7936 4.38281 12.9871 4.38281C15.1806 4.38281 16.9644 6.22905 16.9644 8.49805C16.9644 10.7671 15.1806 12.6146 12.9871 12.6146ZM12.9871 5.34084C11.3045 5.34084 9.93539 6.75783 9.93539 8.49934C9.93539 10.2409 11.3045 11.6579 12.9871 11.6579C14.6697 11.6579 16.0388 10.2409 16.0388 8.49934C16.0388 6.75783 14.6697 5.34084 12.9871 5.34084Z" fill="black" stroke="black"/>
          <path d="M19.304 1.14483C19.4826 0.954776 19.7762 0.950897 19.9585 1.13836C20.1409 1.32325 20.1434 1.62707 19.9648 1.81583L6.67128 15.8565C6.58009 15.9522 6.46017 16 6.34025 16C6.22033 16 6.10666 15.9548 6.01547 15.863C5.8331 15.6781 5.8306 15.3743 6.00923 15.1855" fill="black"/>
          <path d="M19.304 1.14483C19.4826 0.954776 19.7762 0.950897 19.9585 1.13836C20.1409 1.32325 20.1434 1.62707 19.9648 1.81583L6.67128 15.8565C6.58009 15.9522 6.46017 16 6.34025 16C6.22033 16 6.10666 15.9548 6.01547 15.863C5.8331 15.6781 5.8306 15.3743 6.00923 15.1855L19.304 1.14483Z" stroke="black"/>
        </g>
      `;

      // 表示時のSVG
      const visibleSvg = `
        <g opacity="0.4">
          <path d="M12.9872 15.1835C8.27289 15.1835 3.82465 12.7891 1.08525 8.7786C0.971582 8.61311 0.971582 8.39073 1.08525 8.22524C3.8259 4.21343 8.27414 1.82031 12.9872 1.82031C17.7003 1.82031 22.1772 4.21343 24.9166 8.22395C25.0303 8.38944 25.0303 8.61181 24.9166 8.7773C22.1785 12.7878 17.7177 15.1822 12.9872 15.1822V15.1835ZM2.03711 8.50063C4.61536 12.091 8.68386 14.2255 12.9884 14.2255C17.293 14.2255 21.3878 12.091 23.9673 8.50063C21.3878 4.9103 17.3093 2.77704 12.9884 2.77704C8.66762 2.77704 4.61536 4.9103 2.03711 8.50063Z" fill="black" stroke="black"/>
          <path d="M12.9871 12.6146C10.7936 12.6146 9.00977 10.7683 9.00977 8.49805C9.00977 6.22775 10.7936 4.38281 12.9871 4.38281C15.1806 4.38281 16.9644 6.22905 16.9644 8.49805C16.9644 10.7671 15.1806 12.6146 12.9871 12.6146ZM12.9871 5.34084C11.3045 5.34084 9.93539 6.75783 9.93539 8.49934C9.93539 10.2409 11.3045 11.6579 12.9871 11.6579C14.6697 11.6579 16.0388 10.2409 16.0388 8.49934C16.0388 6.75783 14.6697 5.34084 12.9871 5.34084Z" fill="black" stroke="black"/>
        </g>
      `;

      // SVG要素を作成
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "26");
      svg.setAttribute("height", "17");
      svg.setAttribute("viewBox", "0 0 26 17");
      svg.setAttribute("fill", "none");
      
      svg.innerHTML = hiddenSvg;

      svg.addEventListener('click', () => {
        if (input.type === 'password') {
          input.type = 'text';
          svg.innerHTML = visibleSvg;
        } else {
          input.type = 'password';
          svg.innerHTML = hiddenSvg;
        }
      });

      // SVGを入力フィールドの後に挿入
      input.parentElement.appendChild(svg);
    }

    // パスワード入力フィールドを全て取得して実行
    const passwordInputs = document.querySelectorAll('.c_register-password input[type="password"]');
    passwordInputs.forEach(input => {
      createPasswordToggle(input);
    });

    // 利用規約・個人情報保護方針に同意したときのみ会員登録可能に
    const checkbox = document.querySelector('.cf-field.c_customer-agree input');
    const submitButton = document.querySelector('.cf-submit-form');

    if (checkbox && submitButton) {
      if(checkbox.checked) {
        submitButton.disabled = false;
      } else {
        submitButton.disabled = true;
      }

      checkbox.addEventListener('change', function() {
        submitButton.disabled = !this.checked;
      });
    }

    // 誕生日の入力制限
    const valueYears = document.querySelector('select[name="year"]');
    const valueMonth = document.querySelector('select[name="month"]');
    const valueDay = document.querySelector('select[name="day"]');

    if(valueYears && valueMonth && valueDay) {
      if(valueYears.value === '' || valueMonth.value === '' || valueDay.value === '') {
        valueYears.disabled = false;
        valueMonth.disabled = false;
        valueDay.disabled = false;
      } else {
        valueYears.disabled = true;
        valueMonth.disabled = true;
        valueDay.disabled = true;
      }
    }
    
    // 電話番号をデフォルトの住所の電話番号に反映
    const $form = document.querySelector('form[data-cf-form]');
    
    if ($form && $form.cfForm) {
      const cfForm = $form.cfForm;
      
      const POSSIBLE_PHONE_COLUMNS = ['phone', 'telephone', 'phone_number'];
      const DEFAULT_PHONE_COLUMN = 'default_address.phone';
      
      let actualPhoneColumn = null;
      
      cfForm.beforeSave(() => {
        let phoneValue = null;
        for (const column of POSSIBLE_PHONE_COLUMNS) {
          try {
            let value = cfForm.getFieldValue(column);
            if (value && value.trim() !== '') {
              // スペースを除去して形式を統一
              phoneValue = value.replace(/\s+/g, '');
              actualPhoneColumn = column;
              break;
            }
          } catch (e) {
            // フィールドが存在しない場合は続行
          }
        }
        
        if (!phoneValue) {
          const phoneInput = $form.querySelector('input[name="phone"], input[name="telephone"], input[name="phone_number"]');
          if (phoneInput && phoneInput.value && phoneInput.value.trim() !== '') {
            // スペースを除去して形式を統一
            phoneValue = phoneInput.value.replace(/\s+/g, '');
            actualPhoneColumn = phoneInput.name;
          }
        }
        
        if (phoneValue) {
          try {
            cfForm.setFieldValue(DEFAULT_PHONE_COLUMN, phoneValue);
          } catch (e) {
            // エラーが発生しても処理を続行
          }
        }
      });

      // DOM構築完了後に電話番号同期を設定
      setTimeout(() => {
        const phoneInput = $form.querySelector('input[name="phone"], input[name="telephone"], input[name="phone_number"]');
        
        if (phoneInput) {
          // 同期処理を関数として定義
          const syncPhoneNumber = function() {
            let value = this.value.trim();
            
            // スペースを除去して形式を統一
            if (value) {
              value = value.replace(/\s+/g, '');
            }
            
            try {
              cfForm.setFieldValue(DEFAULT_PHONE_COLUMN, value);
            } catch (e) {
              // エラーが発生しても処理を続行
            }
          };
          
          // 各種イベントリスナーを追加（入力変更を確実に捉える）
          phoneInput.addEventListener('input', syncPhoneNumber);
          phoneInput.addEventListener('keyup', syncPhoneNumber);
          phoneInput.addEventListener('change', syncPhoneNumber);
          phoneInput.addEventListener('blur', syncPhoneNumber);
          phoneInput.addEventListener('paste', function() {
            // paste後にDOMが更新されるまで少し待つ
            setTimeout(syncPhoneNumber.bind(this), 10);
          });
          
          // MutationObserverで値の変更を監視（プログラム的な変更も捉える）
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                syncPhoneNumber.call(phoneInput);
              }
            });
          });
          
          observer.observe(phoneInput, {
            attributes: true,
            attributeFilter: ['value']
          });
          
          // 初回読み込み時の同期
          if (phoneInput.value && phoneInput.value.trim()) {
            syncPhoneNumber.call(phoneInput);
          }
        }
      }, 1000); // タイミングを少し遅らせて確実に初期化
    }

    // 日本語都道府県名を英語に変換（cfForm用：マクロンなし）
    function convertJapanesePrefectureToEnglish(japanesePrefecture) {
      const prefectureMap = {
        '北海道': 'Hokkaido',
        '青森県': 'Aomori',
        '岩手県': 'Iwate',
        '宮城県': 'Miyagi',
        '秋田県': 'Akita',
        '山形県': 'Yamagata',
        '福島県': 'Fukushima',
        '茨城県': 'Ibaraki',
        '栃木県': 'Tochigi',
        '群馬県': 'Gunma',
        '埼玉県': 'Saitama',
        '千葉県': 'Chiba',
        '東京都': 'Tokyo',
        '神奈川県': 'Kanagawa',
        '新潟県': 'Niigata',
        '富山県': 'Toyama',
        '石川県': 'Ishikawa',
        '福井県': 'Fukui',
        '山梨県': 'Yamanashi',
        '長野県': 'Nagano',
        '岐阜県': 'Gifu',
        '静岡県': 'Shizuoka',
        '愛知県': 'Aichi',
        '三重県': 'Mie',
        '滋賀県': 'Shiga',
        '京都府': 'Kyoto',
        '大阪府': 'Osaka',
        '兵庫県': 'Hyogo',
        '奈良県': 'Nara',
        '和歌山県': 'Wakayama',
        '鳥取県': 'Tottori',
        '島根県': 'Shimane',
        '岡山県': 'Okayama',
        '広島県': 'Hiroshima',
        '山口県': 'Yamaguchi',
        '徳島県': 'Tokushima',
        '香川県': 'Kagawa',
        '愛媛県': 'Ehime',
        '高知県': 'Kochi',
        '福岡県': 'Fukuoka',
        '佐賀県': 'Saga',
        '長崎県': 'Nagasaki',
        '熊本県': 'Kumamoto',
        '大分県': 'Oita',
        '宮崎県': 'Miyazaki',
        '鹿児島県': 'Kagoshima',
        '沖縄県': 'Okinawa'
      };
      
      return prefectureMap[japanesePrefecture] || '';
    }

    // エラーメッセージを表示する関数
    function showErrorMessage(zipInput, message) {
      const existingError = zipInput.parentElement.querySelector('.zipcode-error-message');
      if (existingError) {
        existingError.remove();
      }

      const errorDiv = document.createElement('div');
      errorDiv.className = 'zipcode-error-message';
      errorDiv.style.cssText = `
        color: #d32f2f;
        font-size: 12px;
        margin-top: 4px;
        padding: 8px 12px;
        background-color: #ffebee;
        border: 1px solid #ffcdd2;
        border-radius: 4px;
        display: flex;
        align-items: center;
      `;
      
      errorDiv.innerHTML = `
        <svg style="margin-right: 6px; flex-shrink: 0;" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
          <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
        </svg>
        <span>${message}</span>
      `;

      zipInput.parentElement.appendChild(errorDiv);

      setTimeout(() => {
        if (errorDiv.parentElement) {
          errorDiv.remove();
        }
      }, 5000);
    }

    // エラーメッセージを非表示にする関数
    function hideErrorMessage(zipInput) {
      const existingError = zipInput.parentElement.querySelector('.zipcode-error-message');
      if (existingError) {
        existingError.remove();
      }
    }

    // 大口事業所かどうかを判定（ポストくんAPIのレスポンスから）
    function isLargeOfficeAddress(addressData) {
      if (addressData.postcode_type === 'office') {
        return true;
      }
      
      if (addressData.office && addressData.office.trim() !== '') {
        return true;
      }
      
      if (addressData.post_type && addressData.post_type.includes('事業所')) {
        return true;
      }
      
      return false;
    }

    // ポストくんAPIを使用して住所を取得
    async function fetchAddressFromZipcode(zipcode, zipInput) {
      if (!$form || !$form.cfForm) {
        return;
      }
      
      const cfForm = $form.cfForm;
      
      try {
        const cleanZipcode = zipcode.replace(/-/g, '');
        const url = `https://postcode.teraren.com/postcodes/${cleanZipcode}.json`;
        
        const response = await fetch(url);
        
        if (!response.ok) {
          if (response.status === 404) {
            showErrorMessage(zipInput, '郵便番号が確認できませんでした。正しい郵便番号を入力してください。');
            return;
          }
          throw new Error(`HTTP Error: ${response.status}`);
        }
        
        const addressData = await response.json();
        
        if (isLargeOfficeAddress(addressData)) {
          showErrorMessage(zipInput, '郵便番号が確認できませんでした。手動で住所を入力してください。');
          return;
        }
        
        hideErrorMessage(zipInput);
        
        const prefectureValue = convertJapanesePrefectureToEnglish(addressData.prefecture);
        cfForm.setFieldValue('default_address.province', prefectureValue);

        const cityValue = (addressData.city || '') + (addressData.suburb || '');
        cfForm.setFieldValue('default_address.city', cityValue);

        cfForm.setFieldValue('default_address.address1', '');
        
      } catch (error) {
        if (error.message.includes('404')) {
          showErrorMessage(zipInput, '郵便番号が確認できませんでした。正しい郵便番号を入力してください。');
        } else {
          showErrorMessage(zipInput, '郵便番号が確認できませんでした。正しい郵便番号を入力してください。');
        }
      }
    }

    // 郵便番号フィールドにイベントリスナーを追加
    const zipInput = document.querySelector('input[name="default_address.zip"]');

    if (zipInput) {
      zipInput.addEventListener('input', function() {
        let zipCode = this.value;
        
        if (zipCode.trim() === '') {
          hideErrorMessage(this);
          return;
        }
        
        if (!/^[0-9-]*$/.test(zipCode)) {
          return;
        }
        
        const cleanZipcode = zipCode.replace(/-/g, '');
        if (cleanZipcode.length === 7) {
          fetchAddressFromZipcode(zipCode, this);
        } else if (cleanZipcode.length > 0 && cleanZipcode.length < 7) {
          hideErrorMessage(this);
        }
      });
      
      zipInput.addEventListener('keyup', function(e) {
        if (!e.key.match(/[0-9]/)) return;
        
        const zipCode = e.target.value;
        const cleanZipcode = zipCode.replace(/-/g, '');
        
        if (cleanZipcode.length === 7) {
          fetchAddressFromZipcode(zipCode, this);
        }
      });
    }
  });

  // エラー時対象の箇所に遷移してフォーカス
  function setSubmitButtonListener() {
    let submitButton = document.querySelector(".cf-submit-form");
    if (submitButton) {
      submitButton.addEventListener("click", function(event) {
        setTimeout(function() {
          let firstErrorField = document.querySelector(".cf-field[data-cf-invalid='true']");
          if (firstErrorField) {
            firstErrorField.scrollIntoView({ block: "center", behavior: "auto" });
            let elementTop = firstErrorField.getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({ top: elementTop, behavior: "auto" });
            let inputField = firstErrorField.querySelector("input, select, textarea");
            if (inputField) {
              inputField.focus();
            }
          }
        }, 150);
      });
    } else {
      setTimeout(setSubmitButtonListener, 500);
    }
  }
  setSubmitButtonListener();

});

// ---
// マイページの会員情報編集
// ---
// お気に入り店舗への遷移
document.addEventListener("DOMContentLoaded", async function () {
    if (window.location.pathname !== "/tools/customr/edit-account") {
        return;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get("scroll") === "favorite-shop") {
        // 要素が生成されるまで待つ関数
        const waitForElement = (selector, maxAttempts = 20, interval = 500) => {
            return new Promise((resolve) => {
                let attempts = 0;
                const checkInterval = setInterval(() => {
                    const element = document.querySelector(selector);
                    if (element) {
                        clearInterval(checkInterval);
                        resolve(element);
                    }
                    if (++attempts >= maxAttempts) {
                        clearInterval(checkInterval);
                        resolve(null);
                    }
                }, interval);
            });
        };

        // 1. まず個人情報入力欄へスクロール
        const personalInfoSection = await waitForElement(".c_customer-personal_information");
        if (personalInfoSection) {
            personalInfoSection.style.scrollMarginTop = "100px";
            personalInfoSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }

        // 2. 次にfavorite-shopへスクロール
        const favoriteShop = await waitForElement(".favorite-shop");
        if (favoriteShop) {
            favoriteShop.style.scrollMarginTop = "100px";
            favoriteShop.scrollIntoView({ behavior: "smooth", block: "start" });

            history.replaceState(null, "", window.location.pathname);
        }
    }
});